import { faPencil } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import { useMyAccount } from '../../../../data/hooks/sessionHooks';
import ButtonLink from '../../../elements/ButtonLink';
import ContainedImage from '../../../elements/ContainedImage';
import HomeLogo from '../../../elements/HomeLogo';
import Link from '../../../elements/Link';
import Scrollable from '../../../elements/Scrollable';
import TopBar from '../../../elements/TopBar/TopBar';
import Screen from '../../Screen';
import styles from './LinkedinNewAccount.module.scss';

const LinkedinNewAccount = (props) => {
    const {} = props,
        i18n = useI18n(),
        prefill = useSelector((state) => state.session.prefill),
        user = useMyAccount();

    const header = (
        <>
            <TopBar returnURL='/'></TopBar>
            <HomeLogo />
            <hr />
            <h1>{i18n['label.new.account']}</h1>
        </>
    );

    return (
        <Screen header={header}>
            <Scrollable>
                <div className='content'>
                    <h4>{i18n['label.linkedin-details']}</h4>
                    <ContainedImage
                        className={styles.avatar}
                        src={user.image_url}
                        altSrc={`/img/no_avatar.png`}
                    />
                    <Link className={styles.edit} href='./name'>
                        {user.first_name} {user.last_name}{' '}
                        <FontAwesomeIcon className={styles.icon} icon={faPencil} />
                    </Link>
                    <Link className={styles.edit} href='./email'>
                        {user.email} <FontAwesomeIcon icon={faPencil} />
                    </Link>
                    <ButtonLink
                        className={[styles.primaryAction, 'primaryaction'].join(
                            ' '
                        )}
                        href={
                            prefill ? `/add/${prefill.code}` : `/new_account`
                        }>
                        {i18n['label.continue']}
                    </ButtonLink>
                </div>
            </Scrollable>
        </Screen>
    );
};

export default LinkedinNewAccount;
